export default {
  and: 'and',
  save: 'Save',
  next: 'Next',
  skip: 'Skip',
  add: 'Add',
  cancel: 'Cancel',
  edit: 'Edit',
  delete: 'Delete',
  remove: 'Remove',
  close: 'Close',
  duplicate: 'Duplicate',
  view: 'View',
  done: 'Done',
  copy: 'Copy',
  copied: 'Copied',

  pages: 'Pages',
  feedback: 'Feedback',

  loading: 'Loading',

  go: 'Go!',
  go_back: 'Go back',

  date: {
    day: 'Day',
    month: 'Month',
    year: 'Year',
  },

  found: 'Found',
  organize_by: 'Organize by',
  filter_by: 'Filter by',

  errors: {
    not_found: {
      code: '404',
      message: 'Page not found',
    },
  },

  gallery: 'Home',
  assignment: 'Assignments',
  classroom: 'Classrooms',

  provider: {
    google: 'Google Classroom',
    pressto: 'Pressto Class',
    regular: 'Regular',
  },

  delete_account_default_message: 'Once you delete, it will be gone forever. Are you sure you want to delete?',
};
